/* ==========================================================================
   Gift roulette popup + prize handling.

   Slices come in three types (built from the config JSON in
   snippets/gift-roulette-popup.liquid):

   - gift: auto-added to the cart once the cart reaches the minimum set in
     theme settings (gift_roulette_minimum), removed again if the cart drops
     below it. The ANNIVERSARYGIFT automatic discount makes it free.
   - discount: an order-level discount code (no minimum). Applied to the
     session immediately via GET /discount/CODE — this works even with an
     empty cart because Shopify stores the code in a session cookie and
     applies it at checkout — and mirrored into the cart with
     POST /cart/update.js once the cart has items so the customer sees it.
   - tryagain: no prize; up to MAX_TRY_AGAIN_SPINS landings re-enable the
     spin (counted in a 7-day cookie); the landing after that writes a
     { type: 'none' } main cookie and shows the no-gift message. Otherwise
     the spin does not consume the 7-day cookie and the
     visitor can spin again right away (repeatedly, until a prize lands).
   ========================================================================== */

(function () {
  var COOKIE_NAME = 'capittana_gift_roulette';
  var ORDER_COOKIE_NAME = 'capittana_order_completed'; // Set by the checkout_completed custom pixel
  // Session cookie: the visitor closed the popup without spinning. While it
  // is set the popup stays away and the top banner offers the roulette.
  var DISMISS_COOKIE_NAME = 'capittana_gift_roulette_dismissed';
  /* Counts try-again landings (7-day cookie, survives reloads). The first
     MAX_TRY_AGAIN_SPINS landings re-enable the spin button; the next one
     is terminal: the main cookie is written as { type: 'none' } and the
     popup shows the no-gift message instead of another spin. */
  var TRIES_COOKIE_NAME = 'capittana_gift_roulette_tries';
  var MAX_TRY_AGAIN_SPINS = 2;
  var COOKIE_MAX_AGE = 604800; // 7 days
  var SPIN_DURATION = 4200; // Slightly above the 4s CSS transition
  var CHECK_INTERVAL = 3500; // Same cadence as the original checkCartAndAddProduct

  var configEl = document.getElementById('gift-roulette-config');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    console.error('Gift roulette: invalid config', e);
    return;
  }

  if (!config.gifts || !config.gifts.length) return;

  var giftVariantIds = config.gifts.map(function (gift) {
    return gift.variantId;
  });

  /* Display names shown on the wheel, winner message and progress bar.
     Edit the values here when the real gift names are decided — no need
     to rename the products in Shopify or fetch anything. */
  var GIFT_DISPLAY_NAMES = {
    'giftcard-house-of-c': 'Giftcard S/.200',
    'wrap-de-regalo': 'Wrap de Regalo',
    /* Kept for cookies written before the dedicated Wrap de Regalo
       product replaced it on the wheel (17 Sep 2026): */
    'wrap-white-crochet': 'Wrap de Regalo',
    'regalo-aviersario-capittana': 'Tote Denim + Microphone',
    /* Kept for cookies written before the dedicated bundle product
       replaced it on the wheel (17 Sep 2026): */
    'the-denim-tote-bag': 'Tote Denim + Microphone',
    'neceser-sorpresa': 'Neceser Sorpresa Esme & Odrilia',
  };

  /* Campaign wheel artwork (assets/gift-roulette-wheel.png; URL arrives in
     the config JSON). Slice centers were measured from the image in degrees
     clockwise from the top pointer — the slices are NOT equal (44° to 56°),
     so each carries its own center. */
  var IMAGE_WHEEL_SLICES = [
    { center: 42.8, type: 'gift', handle: 'giftcard-house-of-c' },  // GIFTCARD S/.200
    { center: 90.0, type: 'discount', percent: 30 },                // 30% OFF SIGUIENTE COMPRA
    { center: 139.3, type: 'tryagain' },                            // SIGUE INTENTANDO
    { center: 194.5, type: 'gift', handle: 'regalo-aviersario-capittana' },  // TOTE DENIM + MICROPHONE
    { center: 250.5, type: 'gift', handle: 'neceser-sorpresa' },    // NECESER SORPRESA
    { center: 306.0, type: 'discount', percent: 20 },               // 20% OFF SIGUIENTE COMPRA
    { center: 355.5, type: 'gift', handle: 'wrap-de-regalo' },      // WRAP DE REGALO
  ];

  /* Relative winning odds per slice; anything not listed weighs 1.
     A discount slice first looks up "discount<percent>", then "discount".
     With 0.05 / 0.03 the 20% slice wins ~1% of spins and the 30% slice
     ~0.6% on the 7-slice wheel instead of the equal-odds 14.3% — the
     wheel still *shows* every slice the same size, only the draw is
     weighted. */
  var SLICE_WEIGHTS = { discount20: 0.05, discount30: 0.03 };

  function sliceWeight(slice) {
    return SLICE_WEIGHTS[slice.type + (slice.percent || '')] ||
      SLICE_WEIGHTS[slice.type] || 1;
  }

  /* ===== Slice list: gifts with the special slices spread out evenly ===== */

  var GIFT_SLICE_COLORS = ['#5B85AF', '#E9E9D5', '#8FA9BF', '#F4F1E6', '#23618F', '#DDE7F0'];
  var GIFT_SLICE_TEXT = ['#ffffff', '#23618F', '#ffffff', '#23618F', '#ffffff', '#23618F'];
  var SPECIAL_COLORS = { discount: '#F2C14E', tryagain: '#9AA5AD' };
  var SPECIAL_TEXT = { discount: '#23618F', tryagain: '#ffffff' };

  function buildSlices() {
    var specials = config.specials || [];
    var total = config.gifts.length + specials.length;
    var specialAt = {};
    specials.forEach(function (special, i) {
      // For 6 gifts + 3 specials this yields indices 2, 5 and 8
      specialAt[Math.floor(((i + 1) * total) / specials.length) - 1] = special;
    });

    var slices = [];
    var giftIndex = 0;
    for (var i = 0; i < total; i++) {
      if (specialAt[i]) {
        var special = specialAt[i];
        slices.push({
          type: special.type,
          code: special.code,
          percent: special.percent,
          label: special.label,
          color: SPECIAL_COLORS[special.type],
          textColor: SPECIAL_TEXT[special.type],
        });
      } else {
        var gift = config.gifts[giftIndex];
        slices.push({
          type: 'gift',
          variantId: gift.variantId,
          title: gift.title,
          handle: gift.handle,
          color: GIFT_SLICE_COLORS[giftIndex % GIFT_SLICE_COLORS.length],
          textColor: GIFT_SLICE_TEXT[giftIndex % GIFT_SLICE_TEXT.length],
        });
        giftIndex++;
      }
    }
    return slices;
  }

  /* Resolves the image slice map against the config: gifts join by handle
     to the collection products, discounts by percent to the configured
     codes. An unresolvable slice stays in the array as null — the artwork
     fixes every slice's angular position, so the wheel simply never lands
     on it. Returns null (→ generated-wheel fallback) without artwork. */
  function buildImageSlices() {
    if (!config.wheelImageUrl) return null;
    var specials = config.specials || [];
    var resolved = IMAGE_WHEEL_SLICES.map(function (def) {
      if (def.type === 'gift') {
        var gift = config.gifts.filter(function (g) { return g.handle === def.handle; })[0];
        if (!gift) return null;
        return {
          type: 'gift', center: def.center,
          variantId: gift.variantId, title: gift.title, handle: gift.handle,
        };
      }
      if (def.type === 'discount') {
        var special = specials.filter(function (s) {
          return s.type === 'discount' && s.percent === def.percent;
        })[0];
        if (!special) return null;
        return {
          type: 'discount', center: def.center,
          code: special.code, percent: special.percent, label: special.label,
        };
      }
      var tryAgain = specials.filter(function (s) { return s.type === 'tryagain'; })[0];
      return { type: 'tryagain', center: def.center, label: tryAgain ? tryAgain.label : '' };
    });
    return resolved.some(Boolean) ? resolved : null;
  }

  var imageSlices = buildImageSlices();
  var imageMode = !!imageSlices;
  var slices = imageSlices || buildSlices();
  var sliceAngle = 360 / slices.length;

  function sliceCenter(index) {
    var slice = slices[index];
    return slice && slice.center != null ? slice.center : index * sliceAngle + sliceAngle / 2;
  }

  function displayName(prize) {
    if (!prize) return '';
    if (prize.type === 'discount') return prize.label || prize.percent + '% DSCTO';
    if (prize.type === 'tryagain') return prize.label || '';
    return GIFT_DISPLAY_NAMES[prize.handle] || prize.title || '';
  }

  function sliceLabel(slice) {
    if (slice.type !== 'gift') return slice.label || '';
    // Same shortening the Liquid template used, but the customized display
    // name wins once it differs from the raw product title
    var custom = GIFT_DISPLAY_NAMES[slice.handle];
    var name = custom && custom !== slice.title ? custom : slice.title.replace('Anniversary ', '');
    return name.length > 14 ? name.slice(0, 14) : name;
  }

  /* Insert the gift name into a settings text: replaces [gift] if present,
     otherwise appends the name at the end. */
  function withGiftName(text, gift) {
    var name = displayName(gift);
    if (!text) return name;
    if (text.indexOf('[gift]') !== -1) return text.replace('[gift]', name);
    return text + (name ? ' ' + name : '');
  }

  function withDiscountTokens(text, won) {
    return (text || '')
      .replace('[code]', won.code || '')
      .replace('[percent]', won.percent != null ? String(won.percent) : '');
  }

  var moneyFormat = '{{amount}}';
  try {
    var globalEl = document.getElementById('wetheme-global');
    if (globalEl) moneyFormat = JSON.parse(globalEl.textContent).moneyFormat || moneyFormat;
  } catch (e) { /* keep fallback */ }

  /* ===== Helpers ===== */

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    if (!match) return null;
    try {
      return JSON.parse(decodeURIComponent(match[1]));
    } catch (e) {
      return null;
    }
  }

  function setCookie(name, value) {
    document.cookie =
      name + '=' + encodeURIComponent(JSON.stringify(value)) +
      '; max-age=' + COOKIE_MAX_AGE + '; path=/; SameSite=Lax';
  }

  function readRawCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function deleteCookie(name) {
    document.cookie = name + '=; max-age=0; path=/; SameSite=Lax';
  }

  function setSessionCookie(name, value) {
    // No max-age: lives until the browser session ends
    document.cookie = name + '=' + value + '; path=/; SameSite=Lax';
  }

  /* Cookies written before the discount/try-again slices existed have no
     type field; they are always gift wins. */
  function wonType(won) {
    if (!won) return null;
    return won.type || (won.variantId ? 'gift' : null);
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    if (/amount_no_decimals/.test(moneyFormat)) amount = String(Math.round(cents / 100));
    if (/amount_with_comma_separator/.test(moneyFormat)) amount = amount.replace('.', ',');
    return moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }

  function refreshCartDrawer() {
    if (window.eventBus && typeof window.eventBus.emit === 'function') {
      window.eventBus.emit('render:cart:drawer');
    }
  }

  /* ===== Discount code application ===== */

  function cartHasCode(cart, code) {
    return (cart.discount_codes || []).some(function (entry) {
      return String(entry.code || '').toUpperCase() === String(code).toUpperCase();
    });
  }

  /* Mirrors the won code into the cart so it is visible before checkout.
     Existing codes are kept: /cart/update.js replaces the whole set. */
  async function applyCodeToCart(cart, code) {
    if (!cart.item_count || cartHasCode(cart, code)) return;
    var codes = (cart.discount_codes || []).map(function (entry) {
      return entry.code;
    });
    codes.push(code);
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') }),
    });
    refreshCartDrawer();
  }

  /* Fetches a single-use code from the coupon pool backend. Resolves to the
     code string, or null on timeout/error/empty pool — the caller then keeps
     the shared fallback code from the theme settings. The 3s timeout is
     shorter than the 4.2s spin, so the wheel animation hides the wait. */
  function fetchUniqueCode(percent) {
    if (!config.couponEndpoint) return Promise.resolve(null);
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = controller && setTimeout(function () { controller.abort(); }, 3000);
    var url = config.couponEndpoint.replace(/\/+$/, '') + '/ruleta/cupon/' + percent;
    return fetch(url, { method: 'POST', signal: controller ? controller.signal : undefined })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        if (timer) clearTimeout(timer);
        return data && data.code ? data.code : null;
      })
      .catch(function () {
        if (timer) clearTimeout(timer);
        return null;
      });
  }

  /* Applies the code to the storefront session. Works with an empty cart:
     Shopify stores it in the discount_code session cookie and checkout
     applies it as soon as there is something to buy. */
  async function applyDiscountToSession(code) {
    try {
      await fetch('/discount/' + encodeURIComponent(code));
    } catch (e) {
      console.error('Gift roulette: discount session apply failed', e);
    }
  }

  /* ===== Progress bars (popup + cart drawer) ===== */

  function updateProgressBars(eligibleCents) {
    var won = getCookie(COOKIE_NAME);
    var type = wonType(won);
    var bars = document.querySelectorAll('[data-gift-progress]');

    bars.forEach(function (bar) {
      // Only a gift win has a minimum to work towards — discounts apply
      // with no minimum, so the bar would be meaningless
      if (type !== 'gift') {
        bar.setAttribute('hidden', '');
        return;
      }
      bar.removeAttribute('hidden');
      if (bar.style.display === 'none') bar.style.display = '';

      var text = bar.querySelector('[data-gift-progress-text]');
      var fill = bar.querySelector('[data-gift-progress-fill]');

      var remaining = Math.max(0, config.minimumCents - eligibleCents);
      var percent = Math.min(100, (eligibleCents / config.minimumCents) * 100);

      if (text) {
        if (remaining === 0) {
          text.textContent = withGiftName(config.barSuccess, won) + ' 🎁';
        } else {
          text.innerHTML =
            config.barBefore + ' <span>' + formatMoney(remaining) + '</span> ' +
            withGiftName(config.barAfter, won);
        }
      }
      if (fill) fill.style.width = percent + '%';
    });
  }

  /* ===== Cart polling: auto add/remove the gift, keep the code applied ===== */

  var cartCheckRunning = false;
  var lastCartToken = null;

  /* In-flight unique-code request. Created at spin start (showResult
     consumes it); the polling re-creates it for a cookie stuck in the
     pending state (reload mid-spin lost the original promise). */
  var pendingCoupon = null;

  /* Settles a pending discount cookie: swaps in the unique code when the
     pool answered, keeps the shared fallback otherwise, and only then lets
     the code reach the session, cart and bars. */
  function resolvePendingCoupon(uniqueCode) {
    var won = getCookie(COOKIE_NAME);
    if (!won || won.type !== 'discount' || !won.pending) return won;
    if (uniqueCode) won.code = uniqueCode;
    delete won.pending;
    setCookie(COOKIE_NAME, won);
    return won;
  }

  async function checkCartAndAddProduct() {
    if (cartCheckRunning) return;
    cartCheckRunning = true;

    try {
      var response = await fetch('/cart.js');
      var cart = await response.json();

      // Cart value that counts towards the gift: everything except the gift
      // products. final_line_price already subtracts discount-code
      // allocations (e.g. an applied roulette coupon), which would make the
      // progress under-count against the minimum — add those back so the
      // bar tracks what the products actually cost.
      var eligibleCents = cart.items.reduce(function (sum, item) {
        if (giftVariantIds.indexOf(item.variant_id) !== -1) return sum;
        var lineTotal = item.final_line_price;
        (item.line_level_discount_allocations || []).forEach(function (allocation) {
          var application = allocation.discount_application || {};
          if (application.type === 'discount_code') lineTotal += allocation.amount || 0;
        });
        return sum + lineTotal;
      }, 0);

      lastCartToken = cart.token;

      var won = getCookie(COOKIE_NAME);
      var type = wonType(won);

      // A gift won before a prize-lineup change is no longer covered by the
      // automatic discount: pull it from the cart (it would be charged) and
      // let the visitor spin the new wheel.
      if (type === 'gift' && giftVariantIds.indexOf(won.variantId) === -1) {
        var retiredInCart = cart.items.some(function (item) {
          return item.variant_id === won.variantId;
        });
        if (retiredInCart) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: String(won.variantId), quantity: 0 }),
          });
          refreshCartDrawer();
        }
        deleteCookie(COOKIE_NAME);
        deleteCookie(TRIES_COOKIE_NAME);
        won = null;
        type = null;
      }

      if (type) {
        // Fallback order detection alongside the checkout_completed pixel:
        // Shopify issues a new cart token when a cart is converted into an
        // order (manually emptying the cart keeps the token). A changed
        // token means the order went through, so reset the roulette.
        if (!won.cartToken) {
          won.cartToken = cart.token; // Backfill for cookies written before this check existed
          setCookie(COOKIE_NAME, won);
        } else if (won.cartToken !== cart.token) {
          // Only a cart that has been seen with items can have been
          // converted into an order. An empty cart's token is not stable
          // (Shopify does not persist the session until an item is added,
          // and GET /discount/CODE can rotate it), so a mismatch there just
          // means a fresh token — not a completed purchase.
          if (won.cartHadItems) {
            deleteCookie(COOKIE_NAME);
            deleteCookie(TRIES_COOKIE_NAME);
            updateProgressBars(eligibleCents);
            return;
          }
          won.cartToken = cart.token;
          setCookie(COOKIE_NAME, won);
        }

        if (cart.item_count > 0 && !won.cartHadItems) {
          won.cartHadItems = true;
          setCookie(COOKIE_NAME, won);
        }

        // A gift product from an earlier (expired) spin would not be covered
        // by the automatic discount: remove it whatever the current prize is.
        var wonVariantId = type === 'gift' ? won.variantId : null;
        var staleGifts = cart.items.filter(function (item) {
          return giftVariantIds.indexOf(item.variant_id) !== -1 && item.variant_id !== wonVariantId;
        });
        for (var i = 0; i < staleGifts.length; i++) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: String(staleGifts[i].variant_id), quantity: 0 }),
          });
          refreshCartDrawer();
        }

        if (type === 'gift') {
          var giftInCart = cart.items.some(function (item) {
            return item.variant_id === won.variantId;
          });

          if (eligibleCents >= config.minimumCents && !giftInCart) {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: won.variantId, quantity: 1 }),
            });
            refreshCartDrawer();
          } else if (eligibleCents < config.minimumCents && giftInCart) {
            // Below the minimum the discount no longer applies: remove the
            // gift so the customer is not charged for it.
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: String(won.variantId), quantity: 0 }),
            });
            refreshCartDrawer();
          }
        } else if (type === 'discount' && won.pending) {
          // Unique code still unresolved: fetch it here only when the spin's
          // own request was lost to a reload; never surface the fallback yet
          if (!pendingCoupon) {
            pendingCoupon = fetchUniqueCode(won.percent).then(function (uniqueCode) {
              pendingCoupon = null;
              var settled = resolvePendingCoupon(uniqueCode);
              if (settled && settled.code) {
                applyDiscountToSession(settled.code).then(checkCartAndAddProduct);
              }
            });
          }
        } else if (type === 'discount' && won.code) {
          // Keep the won code on the cart (it survives in the session cookie
          // either way, but this makes it visible in the cart drawer/page)
          await applyCodeToCart(cart, won.code);
        }
      }

      updateProgressBars(eligibleCents);
    } catch (error) {
      console.error('Gift roulette cart check error:', error);
    } finally {
      cartCheckRunning = false;
    }
  }

  window.checkCartAndAddProduct = checkCartAndAddProduct;

  /* ===== Popup ===== */

  var overlay = document.getElementById('gift-roulette');

  function initPopup() {
    if (!overlay) return;

    var testMode = overlay.dataset.testMode === 'true';
    var delaySeconds = parseInt(overlay.dataset.delay, 10) || 0;
    var wheel = overlay.querySelector('[data-roulette-wheel]');
    var spinButton = overlay.querySelector('[data-roulette-spin]');
    var intro = overlay.querySelector('[data-roulette-intro]');
    var result = overlay.querySelector('[data-roulette-result]');
    var wonTitleEl = overlay.querySelector('[data-roulette-won-title]');
    var wonAfterEl = overlay.querySelector('[data-roulette-won-after]');
    var tryAgainEl = overlay.querySelector('[data-roulette-tryagain]');
    var wonEl = overlay.querySelector('[data-roulette-won]');
    var noGiftEl = overlay.querySelector('[data-roulette-nogift]');
    var spinning = false;
    var triesExhausted = false;
    var currentRotation = 0;

    function buildWheel() {
      if (!wheel) return;
      if (imageMode) {
        // The artwork carries its own colors, labels, ring and center hole
        wheel.classList.add('gift-roulette__wheel--image');
        wheel.style.backgroundImage = 'url("' + config.wheelImageUrl + '")';
        return;
      }
      var stops = slices.map(function (slice, i) {
        return slice.color + ' ' + i * sliceAngle + 'deg ' + (i + 1) * sliceAngle + 'deg';
      });
      wheel.style.background = 'conic-gradient(' + stops.join(', ') + ')';
      wheel.classList.toggle('gift-roulette__wheel--dense', slices.length > 6);

      slices.forEach(function (slice, i) {
        var labelWrap = document.createElement('div');
        labelWrap.className = 'gift-roulette__slice-label';
        labelWrap.style.transform = 'rotate(' + (i * sliceAngle + sliceAngle / 2) + 'deg)';
        var span = document.createElement('span');
        span.style.color = slice.textColor;
        span.textContent = sliceLabel(slice);
        labelWrap.appendChild(span);
        wheel.appendChild(labelWrap);
      });
    }

    var banner = document.getElementById('gift-roulette-banner');
    // The snippet renders near the end of <body>; the banner belongs at the
    // very top of the page, above the header
    if (banner && document.body.firstElementChild !== banner) {
      document.body.insertBefore(banner, document.body.firstChild);
    }

    function showBanner() {
      if (banner) banner.removeAttribute('hidden');
    }

    function hideBanner() {
      if (banner) banner.setAttribute('hidden', '');
    }

    function openPopup() {
      hideBanner();
      overlay.removeAttribute('hidden');
      requestAnimationFrame(function () {
        overlay.classList.add('is-visible');
      });
      var closeButton = overlay.querySelector('[data-roulette-close]');
      if (closeButton) closeButton.focus();
    }

    function closePopup() {
      overlay.classList.remove('is-visible');
      setTimeout(function () {
        overlay.setAttribute('hidden', '');
      }, 300);
      // Closed without a prize: stop auto-opening for this browser session
      // and leave the top banner as the way back in
      if (!getCookie(COOKIE_NAME)) {
        setSessionCookie(DISMISS_COOKIE_NAME, '1');
        showBanner();
      }
    }

    function showTryAgain() {
      spinning = false;
      if (tryAgainEl) tryAgainEl.removeAttribute('hidden');
      if (spinButton) {
        spinButton.textContent = config.spinAgainLabel || spinButton.textContent;
        spinButton.removeAttribute('disabled');
      }
    }

    /* Terminal try-again: reuses the result layout, but with the no-gift
       message instead of the winner line. The continue button closes the
       popup as usual; the { type: 'none' } cookie written at spin start
       blocks further spins for the cookie's 7 days. */
    function showNoGift() {
      if (intro) intro.setAttribute('hidden', '');
      if (spinButton) spinButton.setAttribute('hidden', '');
      if (tryAgainEl) tryAgainEl.setAttribute('hidden', '');
      if (wonEl) wonEl.setAttribute('hidden', '');
      if (noGiftEl) noGiftEl.removeAttribute('hidden');
      if (result) result.removeAttribute('hidden');
    }

    function showResult(prize) {
      spinning = false;

      if (prize.type === 'tryagain') {
        if (triesExhausted) {
          showNoGift();
          return;
        }
        showTryAgain();
        return;
      }

      if (intro) intro.setAttribute('hidden', '');
      if (spinButton) spinButton.setAttribute('hidden', '');
      if (tryAgainEl) tryAgainEl.setAttribute('hidden', '');
      if (wonTitleEl) wonTitleEl.textContent = displayName(prize);
      if (result) result.removeAttribute('hidden');

      if (prize.type === 'discount') {
        // The single-use code was requested at spin start; by now the fetch
        // has resolved (3s timeout < 4.2s spin) with a pool code or null,
        // in which case the shared fallback code from the settings is kept.
        // No code is shown or applied anywhere until this settles.
        if (wonAfterEl) wonAfterEl.textContent = '';
        var couponRequest = pendingCoupon || Promise.resolve(null);
        pendingCoupon = null;
        couponRequest.then(function (uniqueCode) {
          var settled = resolvePendingCoupon(uniqueCode) ||
            { code: prize.code, percent: prize.percent };
          if (wonAfterEl) wonAfterEl.textContent = withDiscountTokens(config.discountWon, settled);
          // Session first (works with an empty cart), then the polling
          // mirrors the code into the cart as soon as it has items
          applyDiscountToSession(settled.code).then(checkCartAndAddProduct);
        });
      } else {
        if (wonAfterEl) wonAfterEl.textContent = config.wonAfterGift || wonAfterEl.textContent;
        checkCartAndAddProduct();
      }
    }

    function spin() {
      if (spinning || !wheel) return;
      spinning = true;
      spinButton.setAttribute('disabled', '');
      if (tryAgainEl) tryAgainEl.setAttribute('hidden', '');

      // Unresolvable image slices are null: they keep their place on the
      // artwork but can never be won. The draw is weighted by slice type
      // (SLICE_WEIGHTS), not uniform.
      var candidates = [];
      var totalWeight = 0;
      slices.forEach(function (slice, i) {
        if (!slice) return;
        var weight = sliceWeight(slice);
        candidates.push({ index: i, weight: weight });
        totalWeight += weight;
      });
      var roll = Math.random() * totalWeight;
      var winnerIndex = candidates[candidates.length - 1].index;
      for (var c = 0; c < candidates.length; c++) {
        roll -= candidates[c].weight;
        if (roll < 0) { winnerIndex = candidates[c].index; break; }
      }
      var prize = slices[winnerIndex];

      // Persist immediately so a reload mid-spin cannot produce a second
      // spin. "Try again" writes nothing: that spin grants a new one anyway.
      // The cart token enables the fallback order detection; the polling
      // backfills it if the cart has not been fetched yet.
      if (prize.type === 'gift') {
        setCookie(COOKIE_NAME, {
          type: 'gift',
          variantId: prize.variantId,
          title: prize.title,
          handle: prize.handle,
          cartToken: lastCartToken || undefined,
        });
      } else if (prize.type === 'discount') {
        // The cookie carries the shared fallback code but stays "pending":
        // nothing shows or applies it until the unique-code fetch settles
        // (showResult swaps in the pool code, or keeps the fallback on
        // failure and clears the flag).
        setCookie(COOKIE_NAME, {
          type: 'discount',
          code: prize.code,
          percent: prize.percent,
          pending: true,
          cartToken: lastCartToken || undefined,
        });
        pendingCoupon = fetchUniqueCode(prize.percent);
      } else if (prize.type === 'tryagain') {
        // Count the landing right away (a reload cannot reset it). Within
        // the allowance nothing else is written — the visitor is entitled
        // to another spin. One landing past it ends the game: the main
        // cookie blocks further spins for the usual 7 days.
        var tries = (parseInt(readRawCookie(TRIES_COOKIE_NAME), 10) || 0) + 1;
        setCookie(TRIES_COOKIE_NAME, tries);
        if (tries > MAX_TRY_AGAIN_SPINS) {
          triesExhausted = true;
          setCookie(COOKIE_NAME, {
            type: 'none',
            cartToken: lastCartToken || undefined,
          });
        }
      }

      // Land the winning slice center under the top pointer. Rotation only
      // ever accumulates so a "try again" re-spin animates smoothly.
      var centerAngle = sliceCenter(winnerIndex);
      currentRotation = currentRotation - (currentRotation % 360) + 5 * 360 + (360 - centerAngle);
      wheel.style.transform = 'rotate(' + currentRotation + 'deg)';

      setTimeout(function () {
        showResult(prize);
      }, SPIN_DURATION);
    }

    overlay.querySelectorAll('[data-roulette-close]').forEach(function (element) {
      element.addEventListener('click', closePopup);
    });
    // Before a prize is won only the X closes (the popup is the pitch);
    // once a gift/coupon is secured in the cookie, backdrop clicks and
    // Escape dismiss it like a normal modal.
    function hasPrize() {
      return !!getCookie(COOKIE_NAME);
    }
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay && !spinning && hasPrize()) closePopup();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hasAttribute('hidden') && !spinning && hasPrize()) {
        closePopup();
      }
    });
    if (spinButton) spinButton.addEventListener('click', spin);

    if (banner) banner.addEventListener('click', openPopup);

    buildWheel();

    var alreadyPlayed = !!getCookie(COOKIE_NAME);
    var dismissed = readRawCookie(DISMISS_COOKIE_NAME) !== null;
    if (testMode || (!alreadyPlayed && !dismissed)) {
      setTimeout(openPopup, delaySeconds * 1000);
    } else if (!alreadyPlayed && dismissed) {
      showBanner();
    }
  }

  /* ===== Boot ===== */

  function boot() {
    // The "Gift roulette reset" custom pixel (Admin → Settings → Customer
    // events) sets this marker on checkout_completed. A finished order
    // resets the roulette so the customer can spin again.
    if (readRawCookie(ORDER_COOKIE_NAME) !== null) {
      deleteCookie(ORDER_COOKIE_NAME);
      deleteCookie(COOKIE_NAME);
      deleteCookie(DISMISS_COOKIE_NAME);
      deleteCookie(TRIES_COOKIE_NAME);
    }

    initPopup();
    checkCartAndAddProduct();
    setInterval(checkCartAndAddProduct, CHECK_INTERVAL);

    // Re-apply the cart drawer bar after the drawer re-renders its content
    if (window.eventBus && typeof window.eventBus.on === 'function') {
      ['update:cart:drawer', 'render:cart:drawer'].forEach(function (eventName) {
        window.eventBus.on(eventName, function () {
          setTimeout(checkCartAndAddProduct, 150);
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
